import { EventEmitter, Component, forwardRef, ElementRef, Inject, PLATFORM_ID, Optional, Renderer2, ViewChild, Input, Output, HostListener, InjectionToken, NgModule } from '@angular/core';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import { LoadingModule } from '@techmore/loading';
import { loadLazyCssFile, isNullOrUndefined, closestPolifill, GlobalModule } from '@techmore/global';
import { EMPTY } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/upload-setting.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 檔案上傳設定
 */
class UploadSetting {
}
if (false) {
    /** @type {?} */
    UploadSetting.prototype.size;
    /** @type {?} */
    UploadSetting.prototype.type;
    /** @type {?} */
    UploadSetting.prototype.clippedInfos;
}
/**
 * 裁切資訊
 */
class ClippedInfo {
}
if (false) {
    /** @type {?} */
    ClippedInfo.prototype.height;
    /** @type {?} */
    ClippedInfo.prototype.width;
    /** @type {?} */
    ClippedInfo.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/upload/upload.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 檔案上傳
 */
class UploadComponent {
    /**
     * @param {?} el
     * @param {?} platformId
     * @param {?} document
     * @param {?} assets
     * @param {?} render
     */
    constructor(el, platformId, document, assets, render) {
        this.el = el;
        this.platformId = platformId;
        this.document = document;
        this.assets = assets;
        this.render = render;
        this.files = [];
        /**
         * 是否正在上傳中
         */
        this.loading = false;
        /**
         * 是否為單檔上傳
         */
        this.single = false;
        /**
         * 是否要有檔案描述功能
         */
        this.depict = false;
        /**
         * 是否為可編輯狀態
         */
        this.disabled = false;
        this.label = {
            uploadType: '上傳格式:',
            dropAreaText: '拖曳檔案至此範圍內'
        };
        /**
         * 是否顯示副檔名列，預設為顯示
         */
        this.showFileType = true;
        /**
         * 檔案上傳失敗事件
         */
        this.uploadFailedEvent = new EventEmitter();
        /**
         * 上傳檔案到到服務器
         * @param formData 檔案數據
         * @param type 檔案類型
         * @return 上傳到服務器後的回傳值
         */
        this.upload2Serv = (/**
         * @param {?} type
         * @param {?} formData
         * @return {?}
         */
        (type, formData) => EMPTY);
        this.propagateChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.touch = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * 載入插件的方法
     * @param {?} document
     * @param {?} renderer
     * @param {?} parentEl
     * @param {?} assetsConfig
     * @return {?}
     */
    static loadPlugin(document, renderer, parentEl, assetsConfig) {
        assetsConfig.styles.forEach((/**
         * @param {?} st
         * @return {?}
         */
        st => {
            /** @type {?} */
            const sta = st.split('/');
            /** @type {?} */
            const stName = sta[sta.length - 1];
            loadLazyCssFile(document, renderer, parentEl, stName, st);
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.type) {
            throw new Error('Need Type!');
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            UploadComponent.loadPlugin(this.document, this.render, this.el.nativeElement, this.assets || uploadAssetsDefaultConfig);
        }
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj) {
            this.files = obj;
            this.sortFiles();
        }
        else if (this.files && this.files.length > 0) {
            this.files = [];
            this.propagateChange(this.files);
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.touch = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled ? true : false;
    }
    /**
     * 表單驗證
     * @param {?} c 表單控件
     * @return {?}
     */
    validate(c) {
        if (isNullOrUndefined(this.require) || this.files.length >= this.require) {
            return null;
        }
        return { fileUploader: this.require };
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        if (!this.disabled) {
            this.fileInputRef.nativeElement.click();
            this.touch('');
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onDragover($event) {
        $event.preventDefault();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onDrop($event) {
        $event.preventDefault();
        if (!this.disabled) {
            this.touch('');
            this.upload($event.dataTransfer.files);
        }
    }
    /**
     * 檔案上傳輸入控件的資料改變
     * @param {?} $event
     * @return {?}
     */
    fileInputOnChange($event) {
        $event.stopPropagation();
        this.upload(this.fileInputRef.nativeElement.files);
        this.fileInputRef.nativeElement.value = '';
    }
    /**
     * 上傳檔案
     * @param {?} files
     * @return {?}
     */
    upload(files) {
        /** @type {?} */
        const length = files.length;
        for (let i = 0; i < length; i++) {
            if (!this.checkExt(files[i].name.split('.').pop())) {
                this.uploadFailedEvent.emit({ code: 'E1', msg: 'wrong format' });
                continue;
            }
            if (!this.checkSize(files[i].size)) {
                this.uploadFailedEvent.emit({ code: 'E2', msg: 'wrong size' });
                continue;
            }
            /** @type {?} */
            const formData = new FormData();
            formData.append('qqfile', files[i]);
            this.onUploadStart();
            /** @type {?} */
            const file = {
                name: files[i].name,
                progress: 0
            };
            if (files[i].size) {
                file.size = files[i].size;
            }
            /** @type {?} */
            let fileIndex;
            this.upload2Serv(this.type, formData).subscribe((/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        if (this.single) {
                            this.files.length = 0;
                        }
                        this.files.push(file);
                        fileIndex = this.files.length - 1;
                        break;
                    case HttpEventType.UploadProgress:
                        file.progress = Math.round(event.loaded / event.total * 100);
                        break;
                    case HttpEventType.Response:
                        this.onUploadFinish(file, event.body);
                }
            }), (/**
             * @param {?} error
             * @return {?}
             */
            error => this.onUploadFailed(error, file, fileIndex)));
        }
    }
    /**
     * 檔案上傳到服務器完畢
     * @param {?} file 上傳的檔案
     * @param {?} uploadFeedBack
     * @return {?}
     */
    onUploadFinish(file, uploadFeedBack) {
        file.name = uploadFeedBack.name;
        file.fileid = uploadFeedBack.fileid;
        file.thumbnailUrl = uploadFeedBack.thumbnailUrl;
        file.transform = uploadFeedBack.transform;
        this.sortFiles();
        this.propagateChange(this.files);
        this.triggerDomChangeEvent();
        this.onUploadFinsihed();
    }
    /**
     * 檔案上傳到服務器失敗
     * @param {?} error 錯誤
     * @param {?} file 上傳失敗的檔案
     * @param {?} fileIndex 在檔案列表中的索引
     * @return {?}
     */
    onUploadFailed(error, file, fileIndex) {
        this.uploadFailedEvent.emit({ code: 'E3', msg: error, fileName: file.name });
        this.onUploadFinsihed();
        this.files.splice(fileIndex, 1);
    }
    /**
     * 檢查檔案類型
     * @param {?} ext
     * @return {?}
     */
    checkExt(ext) {
        if (isNullOrUndefined(ext)) {
            return false;
        }
        if (this.uploadSetting.type.length === 0) {
            return true;
        }
        return this.uploadSetting.type.findIndex((/**
         * @param {?} val
         * @return {?}
         */
        (val) => ext.toLocaleLowerCase() === val.toLocaleLowerCase())) >= 0;
    }
    /**
     * 檢查檔案大小
     * @param {?} size
     * @return {?}
     */
    checkSize(size) {
        if (isNullOrUndefined(size)) {
            return false;
        }
        return this.uploadSetting.size >= size;
    }
    /**
     * @param {?} $event
     * @param {?} file
     * @return {?}
     */
    deleteFile($event, file) {
        $event.preventDefault();
        this.stopPropagation($event);
        /** @type {?} */
        const index = this.files.findIndex((/**
         * @param {?} val
         * @return {?}
         */
        (val) => val === file));
        this.files.splice(index, 1);
        this.propagateChange(this.files);
        this.triggerDomChangeEvent();
    }
    /**
     * 停止冒泡
     * @param {?} $event
     * @return {?}
     */
    stopPropagation($event) {
        $event.stopPropagation();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    addDataDes($event) {
        this.propagateChange($event);
    }
    /**
     * 檔案上傳開始
     * @return {?}
     */
    onUploadStart() {
        this.loading = true;
    }
    /**
     * 檔案上傳結束
     * @return {?}
     */
    onUploadFinsihed() {
        this.loading = false;
    }
    /**
     * 按照檔名排序(升序)
     * @return {?}
     */
    sortFiles() {
        this.files = this.files.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        (a, b) => {
            if (a.name && b.name) {
                return a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase() ? 1 : -1;
            }
            else {
                return -1;
            }
        }));
    }
    /**
     * 檔案上傳後要手動觸發原生change事件
     * @return {?}
     */
    triggerDomChangeEvent() {
        /** @type {?} */
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('change', { bubbles: true, cancelable: true });
        }
        else {
            event = document.createEvent('Event');
            event.initEvent('change', true, true);
        }
        this.el.nativeElement.dispatchEvent(event);
    }
}
UploadComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-upload',
                template: "<description [class.deny]=\"disabled\" [category]=\"'file'\" [isDepict]=\"depict\" [dataSet]=\"uploadSetting\" [dataDetail]=\"files\" (dataDescription)=\"addDataDes($event)\"></description>\r\n<div *ngIf=\"uploadSetting && showFileType\" class=\"col-4\" style=\"padding: 0.375rem 0.75rem; text-align: left;\">{{ label.uploadType }}<span class=\"extention\">{{uploadSetting.type}}</span></div>\r\n<div class=\"qq-uploader-selector qq-uploader qq-gallery\" attr.qq-drop-area-text=\"{{ label.dropAreaText }}\" [style.cursor]=\"disabled? 'not-allowed':''\">\r\n  <input type=\"file\" class=\"sr-only\" [id]=\"name\"  [multiple]=\"!single\" (change)=\"fileInputOnChange($event)\" #fileInput>\r\n  <ul class=\"qq-upload-list\" [class.deny]=\"disabled\" *ngIf=\"uploadSetting\">\r\n    <li class=\"col-md-6 col-sm-6\" *ngFor=\"let file of files\" (click)=\"stopPropagation($event)\">\r\n      <ng-container *ngIf=\"file.thumbnailUrl; else fileTmp\">\r\n        <a target=\"_blank\" href=\"{{file.thumbnailUrl}}\">\r\n          <ng-container *ngTemplateOutlet=\"fileTmp\"></ng-container>\r\n        </a>\r\n      </ng-container>\r\n      <ng-template #fileTmp>\r\n        <div class=\"qq-file-name\">\r\n          <span class=\"qq-upload-file\" style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis;\" title=\"{{file.name}}\">{{file.name}}</span>\r\n        </div>\r\n        <!-- <br><span class=\"qq-upload-size\">{{ file.size | fileSize }}</span> -->\r\n        <div *ngIf=\"!file.fileid && file.progress > 0\" class=\"progress form-group\">\r\n          <div class=\"progress-bar progress-bar-striped bg-success\" role=\"progressbar\" [style.width.%]=\"file.progress\"></div>\r\n        </div>\r\n        <button *ngIf=\"file.fileid\" type=\"button\" class=\"qq-btn qq-upload-delete\" (click)=\"deleteFile($event, file)\">\r\n          <span aria-label=\"Delete\" class=\"fa fa-trash\"></span>\r\n        </button>\r\n      </ng-template>\r\n    </li>\r\n  </ul>\r\n  <tm-loading [show]=\"loading\"></tm-loading>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => UploadComponent)),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => UploadComponent)),
                        multi: true,
                    }
                ],
                styles: ["a:hover{opacity:.7;transition:.3s}.qq-uploader{min-height:204px}li,ul{margin:0;padding:0}.qq-upload-list{margin:0;padding:0;list-style:none;max-height:524px;overflow-y:auto;clear:both}.qq-upload-list a:focus,.qq-upload-list a:hover{color:#23527c;text-decoration:none!important}.qq-upload-cancel,.qq-upload-continue,.qq-upload-delete,.qq-upload-pause,.qq-upload-retry{font-size:1.5rem;font-weight:400;cursor:pointer;vertical-align:middle}.qq-upload-size{font-size:1.3rem;font-weight:400;cursor:pointer;vertical-align:middle}.qq-upload-crop{font-size:1.4rem;font-weight:400;cursor:pointer;vertical-align:middle;background-color:#e69915;color:#fafafa!important;border-color:#e69915}.qq-upload-crop:hover{background-color:#e9ad45}.qq-upload-delete{background-color:#e65c47;color:#fafafa;border-color:#dc523d}.qq-upload-delete:hover{background-color:#f56b56}.qq-btn{padding:3px 4px;border:0 solid #ccc;border-radius:2px;margin-top:6px;margin-bottom:6px}.glyphicon{position:relative;top:1px;display:inline-block;font-family:glyphicons-halflings-regular;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px}.glyphicon-scissors:before{content:\"\\E226\"}.fa{display:inline-block;font:14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px}.fa-trash:before{content:\"\\F1F8\"}.qq-file-name{display:inline-block}.qq-upload-file{vertical-align:middle;display:inline-block;width:300px;text-overflow:ellipsis;white-space:nowrap;overflow-x:hidden;height:20px}.qq-upload-list li{text-align:left!important;margin:0;padding:9px;line-height:15px;font-size:1.6rem;color:#424242;background-color:#f6f6f6;border-top:1px solid #fff;border-bottom:1px solid #ddd}.deny{cursor:not-allowed;pointer-events:none;background-color:transparent}.progress{height:14px;margin:0!important;padding:0!important;box-shadow:none}.extention{word-break:break-all}::ng-deep .qq-thumbnail-selector{margin-right:0}"]
            }] }
];
/** @nocollapse */
UploadComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [UPLOAD_ASSETS,] }] },
    { type: Renderer2 }
];
UploadComponent.propDecorators = {
    fileInputRef: [{ type: ViewChild, args: ['fileInput', { static: false },] }],
    uploadSetting: [{ type: Input }],
    type: [{ type: Input }],
    name: [{ type: Input }],
    single: [{ type: Input }],
    require: [{ type: Input }],
    depict: [{ type: Input }],
    disabled: [{ type: Input }],
    label: [{ type: Input }],
    showFileType: [{ type: Input }],
    uploadFailedEvent: [{ type: Output }],
    upload2Serv: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }],
    onDragover: [{ type: HostListener, args: ['dragover', ['$event'],] }],
    onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
if (false) {
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    UploadComponent.prototype.isBrowser;
    /** @type {?} */
    UploadComponent.prototype.fileInputRef;
    /** @type {?} */
    UploadComponent.prototype.files;
    /**
     * 是否正在上傳中
     * @type {?}
     */
    UploadComponent.prototype.loading;
    /**
     * 檔案上傳設定
     * @type {?}
     */
    UploadComponent.prototype.uploadSetting;
    /**
     * 上傳檔案的類型
     * @type {?}
     */
    UploadComponent.prototype.type;
    /**
     * 表單控件名
     * @type {?}
     */
    UploadComponent.prototype.name;
    /**
     * 是否為單檔上傳
     * @type {?}
     */
    UploadComponent.prototype.single;
    /**
     * 最少須上傳的數量
     * @type {?}
     */
    UploadComponent.prototype.require;
    /**
     * 是否要有檔案描述功能
     * @type {?}
     */
    UploadComponent.prototype.depict;
    /**
     * 是否為可編輯狀態
     * @type {?}
     */
    UploadComponent.prototype.disabled;
    /** @type {?} */
    UploadComponent.prototype.label;
    /**
     * 是否顯示副檔名列，預設為顯示
     * @type {?}
     */
    UploadComponent.prototype.showFileType;
    /**
     * 檔案上傳失敗事件
     * @type {?}
     */
    UploadComponent.prototype.uploadFailedEvent;
    /**
     * 上傳檔案到到服務器
     * \@param formData 檔案數據
     * \@param type 檔案類型
     * \@return 上傳到服務器後的回傳值
     * @type {?}
     */
    UploadComponent.prototype.upload2Serv;
    /** @type {?} */
    UploadComponent.prototype.propagateChange;
    /** @type {?} */
    UploadComponent.prototype.touch;
    /**
     * @type {?}
     * @protected
     */
    UploadComponent.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    UploadComponent.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    UploadComponent.prototype.document;
    /**
     * @type {?}
     * @protected
     */
    UploadComponent.prototype.assets;
    /**
     * @type {?}
     * @protected
     */
    UploadComponent.prototype.render;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/img-upload/img-upload.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 圖檔上傳
 */
class ImgUploadComponent extends UploadComponent {
    constructor() {
        super(...arguments);
        this.isCrop = false;
        this.showRepresent = true;
        this.label = {
            uploadType: '上傳格式:',
            dropAreaText: '拖曳檔案至此範圍內',
            representImg: '代表圖像',
            setRepresentImgTitle: '預設代表圖像',
        };
        this.openCrop = new EventEmitter();
        this.crop2Serv = (/**
         * @param {?} cropDetail
         * @return {?}
         */
        (cropDetail) => EMPTY);
    }
    /**
     * @param {?} file
     * @param {?} files
     * @return {?}
     */
    representImg(file, files) {
        files.map((/**
         * @param {?} x
         * @return {?}
         */
        x => x.represent = false));
        file.represent = !file.represent;
        this.propagateChange(files);
    }
    /**
     * @param {?} $event
     * @param {?} file
     * @param {?} type
     * @return {?}
     */
    onOpenCrop($event, file, type) {
        $event.preventDefault();
        this.openCrop.emit({ file: (file), setting: this.uploadSetting });
    }
    /**
     * @param {?} file
     * @param {?} uploadFeedBack
     * @return {?}
     */
    onUploadFinish(file, uploadFeedBack) {
        file.name = uploadFeedBack.name;
        file.fileid = uploadFeedBack.fileid;
        file.thumbnailUrl = uploadFeedBack.thumbnailUrl;
        file.transform = uploadFeedBack.transform;
        this.sortFiles();
        /** @type {?} */
        const represent = this.files.map((/**
         * @param {?} x
         * @return {?}
         */
        (x) => x.represent)).indexOf(true);
        if (represent < 0) {
            this.files[0].represent = true;
        }
        this.propagateChange(this.files);
        this.triggerDomChangeEvent();
        this.onUploadFinsihed();
    }
}
ImgUploadComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-img-upload',
                template: "<description [class.deny]=\"disabled\" [category]=\"'image'\" [isDepict]=\"depict\" [dataSet]=\"uploadSetting\" [dataDetail]=\"files\" (dataDescription)=\"addDataDes($event)\"></description>\r\n<div *ngIf=\"uploadSetting && showFileType\" class=\"col-4\" style=\"padding: 0.375rem 0.75rem; text-align: left;\">{{ label.uploadType }}<span class=\"extention\">{{uploadSetting.type}}</span></div>\r\n<div class=\"qq-uploader-selector qq-uploader qq-gallery\" attr.qq-drop-area-text=\"{{ label.dropAreaText }}\" [style.cursor]=\"disabled? 'not-allowed':''\">\r\n  <input type=\"file\" style=\"display: none\" [id]=\"name\" [multiple]=\"!single\" (change)=\"fileInputOnChange($event)\" #fileInput>\r\n  <ul class=\"qq-upload-list\" *ngIf=\"uploadSetting\" [class.deny]=\"disabled\">\r\n    <li class=\"col-md-3 col-sm-6 qq-upload-list-selector\" *ngFor=\"let file of files; let i = index\" (click)=\"stopPropagation($event)\">\r\n      <ng-container *ngIf=\"file.thumbnailUrl; else fileTmp\">\r\n        <a target=\"_blank\" href=\"{{file.thumbnailUrl}}\">\r\n          <ng-container *ngTemplateOutlet=\"fileTmp\"></ng-container>\r\n        </a>\r\n      </ng-container>\r\n      <ng-template #fileTmp>\r\n        <div class=\"qq-thumbnail-wrapper\">\r\n          <img class=\"qq-thumbnail-selector\" [src]=\"file.thumbnailUrl\" >\r\n        </div>\r\n        <div class=\"qq-default-image\" *ngIf=\"showRepresent && ((type == 'gallery') || (type == 'collection'))\">\r\n          <label>{{ label.representImg }}</label>\r\n          <input title=\"{{ label.setRepresentImgTitle }}\" type=\"radio\" [value]=\"file.fileid\"  [checked]=\"file.represent\" (change)=\"representImg(file,files)\" name=\"defaultImg-{{type}}-{{i}}\">\r\n        </div>\r\n        <div class=\"qq-file-info\">\r\n          <div style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis;\"><span>{{file.name}}</span></div>\r\n          <ng-container *ngIf=\"!file.fileid && file.progress > 0\">\r\n            <!-- <span class=\"qq-upload-size\">{{ file.size | fileSize }}</span> -->\r\n            <div class=\"progress form-group\">\r\n              <div class=\"progress-bar progress-bar-striped bg-success\" role=\"progressbar\" [style.width.%]=\"file.progress\"></div>\r\n            </div>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"file.fileid\">\r\n            <button *ngIf=\"isCrop\" class=\"qq-btn qq-upload-crop qq-upload-crop-selector\" type=\"button\" (click)=\"onOpenCrop($event, file, type)\">\r\n              <span aria-label=\"Crop\" class=\"glyphicon glyphicon-scissors\"></span>\r\n            </button>\r\n            <button class=\"qq-btn qq-upload-delete-selector qq-upload-delete\" type=\"button\" (click)=\"deleteFile($event, file)\">\r\n              <span aria-label=\"Delete\" class=\"fa fa-trash\"></span>\r\n            </button>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n    </li>\r\n  </ul>\r\n  <tm-loading [show]=\"loading\"></tm-loading>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => ImgUploadComponent)),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => ImgUploadComponent)),
                        multi: true,
                    }
                ],
                styles: [".qq-upload-list{margin:0;padding:0;list-style:none;max-height:530px;overflow-y:auto;clear:both}.qq-upload-list a:focus,.qq-upload-list a:hover{color:#23527c;text-decoration:none!important}.qq-thumbnail-wrapper{height:180px;border:1px solid #ccc;margin-bottom:5px;margin-top:1px;text-align:center}.qq-thumbnail-wrapper img{width:auto;max-height:150px;max-width:86%}.qq-thumbnail-wrapper:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}.qq-default-image,.qq-file-info{text-align:center}.qq-upload-cancel,.qq-upload-continue,.qq-upload-delete,.qq-upload-pause,.qq-upload-retry{font-size:1.5rem;font-weight:400;cursor:pointer;vertical-align:middle}.qq-upload-size{font-size:1.2rem;margin:7px auto 5px;display:block}.qq-upload-crop{font-size:1.4rem;font-weight:400;cursor:pointer;vertical-align:middle;background-color:#e69915;color:#fafafa!important;border-color:#e69915}.qq-upload-crop:hover{background-color:#e9ad45}.qq-upload-delete{background-color:#e65c47;color:#fafafa;border-color:#dc523d}.qq-upload-delete:hover{background-color:#f56b56}.qq-btn{padding:3px 4px;border:0 solid #ccc;border-radius:2px;margin-top:7px;margin-bottom:15px}.glyphicon{position:relative;top:1px;display:inline-block;font-family:\"Glyphicons Halflings\";font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px}.glyphicon-scissors:before{content:\"\\E226\"}.fa{display:inline-block;font:14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:16px;height:16px}.fa-trash:before{content:\"\\F1F8\"}.qq-file-name{display:inline-block}.qq-upload-file{vertical-align:middle;display:inline-block;width:300px;text-overflow:ellipsis;white-space:nowrap;overflow-x:hidden;height:20px}.qq-upload-list li{text-align:left!important;margin:0;padding:9px;line-height:15px;font-size:1.6rem;color:#424242;background-color:#f6f6f6;border-top:1px solid #fff;border-bottom:1px solid #ddd}.deny{cursor:not-allowed;pointer-events:none;background-color:transparent}.progress{height:14px;margin-bottom:15px;margin-top:15px;padding:0 15px!important;box-shadow:none;background:0 0}.extention{word-break:break-all}::ng-deep .qq-thumbnail-selector{margin-right:0}"]
            }] }
];
ImgUploadComponent.propDecorators = {
    isCrop: [{ type: Input }],
    showRepresent: [{ type: Input }],
    label: [{ type: Input }],
    openCrop: [{ type: Output }],
    crop2Serv: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ImgUploadComponent.prototype.isCrop;
    /** @type {?} */
    ImgUploadComponent.prototype.showRepresent;
    /** @type {?} */
    ImgUploadComponent.prototype.label;
    /** @type {?} */
    ImgUploadComponent.prototype.openCrop;
    /** @type {?} */
    ImgUploadComponent.prototype.crop2Serv;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/description/description.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DescriptionComponent {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.dataDescription = new EventEmitter();
        this.isDepict = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    dataDetailModal($event) {
        $event.stopPropagation();
        this.dataDescriptionModal.open();
    }
    /**
     * @param {?} imgUrl
     * @return {?}
     */
    safeURL(imgUrl) {
        return this.sanitizer.bypassSecurityTrustUrl(imgUrl);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    addDescription(data) {
        this.dataDescription.emit(data);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    imgModal($event) {
        $event.stopPropagation();
        this.hyperlinkModal.open();
    }
}
DescriptionComponent.decorators = [
    { type: Component, args: [{
                selector: 'description',
                template: "<div class=\"container-fluid row mb-1\" *ngIf=\"dataDetail && dataSet && isDepict\">\r\n  <div class=\"col-2\">\r\n    <div class=\"btn btn-warning\" (click)=\"dataDetailModal($event)\">{{category == 'file'? '\u6A94\u6848':'\u5716\u7247'}}\u8CC7\u8A0A</div>\r\n    <!--<div *ngIf=\"category != 'file'\" class=\"btn btn-warning\" (click)=\"imgModal($event)\">\u8D85\u9023\u7D50</div>-->\r\n  </div>\r\n</div>\r\n\r\n<tm-modal [modalConfig]=\"{width: '900px'}\" #dataDescriptionModal>\r\n  <tm-modal-body *ngIf=\"dataDetail && dataSet\">\r\n    <div #tmModalBody class=\"container-fluid\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n          <!-- main Content -->\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12 col-sm-12 col-xs-12\">\r\n              <div class=\"panel panel-default\">\r\n                <div class=\"panel-body\">\r\n                  <div class=\"col-md-10 col-sm-12 responsive-1024\">\r\n                    <div class=\"fake_h4\">{{category == 'file'? '\u6A94\u6848':'\u5716\u7247'}}\u8CC7\u8A0A\u4FEE\u6539</div>\r\n                    <div class=\"col-md-12 twrap\">\r\n                      <div class=\"col-md-12 thead\">\r\n                        <div class=\"col-md-6\">\r\n                          {{category == 'file'? '\u6A94\u6848\u540D\u7A31':'\u5716\u7247\u6A23\u5F0F'}}\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n                          {{category == 'file'? '\u63CF\u8FF0\u5167\u5BB9':'\u5716\u8AAA\u6587\u5B57'}}\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"col-md-12 tbody\">\r\n                        <div class=\"col-md-12 tcell\" *ngFor=\"let item of dataDetail; let i =index\">\r\n                          <div class=\"col-md-6\">\r\n                            <img *ngIf=\"category != 'file'\" [src]=\"safeURL(item.thumbnailUrl)\" class=\"img-responsive\">\r\n                            <span *ngIf=\"category == 'file'\" >{{item.name}}</span>\r\n                          </div>\r\n                          <div class=\"col-md-6\">\r\n                            <textarea cols=\"30\" rows=\"5\" (change)=\"addDescription(dataDetail)\" [(ngModel)]=\"item.description\" name=\"description\"></textarea>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </tm-modal-body>\r\n  <tm-modal-footer>\r\n    <button #tmModalFooter type=\"button\" class=\"btn btn-primary\" (click)=\"dataDescriptionModal.close()\">\u9001\u51FA</button>\r\n  </tm-modal-footer>\r\n</tm-modal>\r\n\r\n<tm-modal [modalConfig]=\"{width: '900px'}\" #hyperlinkModal >\r\n  <tm-modal-body *ngIf=\"dataSet\">\r\n    <div #tmModalBody class=\"container-fluid\">\r\n      <div class=\"row\">\r\n        <h4>\u4EE3\u8868\u5716\u8D85\u9023\u7D50</h4>\r\n        <input class=\"form-control\" type=\"text\" placeholder=\"\u8ACB\u8F38\u5165\u4EE3\u8868\u5716\u7DB2\u5740\" name=\"imgLink\" [ngModel]=\"imgLinkData\">\r\n      </div>\r\n    </div>\r\n  </tm-modal-body>\r\n  <tm-modal-footer>\r\n    <button #tmModalFooter type=\"button\" class=\"btn btn-primary\" (click)=\"hyperlinkModal.close()\">\u9001\u51FA</button>\r\n  </tm-modal-footer>\r\n</tm-modal>\r\n",
                styles: [".twrap{margin-top:1em}.thead{border-bottom:3px solid hsla(0,0%,20%,1);font-size:1em;padding:10px}.tbody{padding-top:10px}.tcell:not(:last-child){border-bottom:3px solid hsl(0 ,0%,0%);margin-bottom:5px}"]
            }] }
];
/** @nocollapse */
DescriptionComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
DescriptionComponent.propDecorators = {
    dataDetail: [{ type: Input }],
    dataSet: [{ type: Input }],
    category: [{ type: Input }],
    dataDescription: [{ type: Output }],
    isDepict: [{ type: Input }],
    dataDescriptionModal: [{ type: ViewChild, args: ['dataDescriptionModal', { static: false },] }],
    hyperlinkModal: [{ type: ViewChild, args: ['hyperlinkModal', { static: false },] }]
};
if (false) {
    /** @type {?} */
    DescriptionComponent.prototype.dataDetail;
    /** @type {?} */
    DescriptionComponent.prototype.dataSet;
    /** @type {?} */
    DescriptionComponent.prototype.category;
    /** @type {?} */
    DescriptionComponent.prototype.dataDescription;
    /** @type {?} */
    DescriptionComponent.prototype.isDepict;
    /** @type {?} */
    DescriptionComponent.prototype.imgLinkData;
    /** @type {?} */
    DescriptionComponent.prototype.dataDescriptionModal;
    /** @type {?} */
    DescriptionComponent.prototype.hyperlinkModal;
    /**
     * @type {?}
     * @private
     */
    DescriptionComponent.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/upload.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const UPLOAD_ASSETS = new InjectionToken('UPLOAD_ASSETS');
/** @type {?} */
const uploadAssetsDefaultConfig = {
    styles: ['/css/uploader.bundle.css']
};
/**
 * 檔案上傳模組
 * 在引用套件的模組提供 UPLOAD_ASSETS 這個依賴項目
 * ```typescript
 * {provide: UPLOAD_ASSETS, useValue: {
 *   styles:  ['/css/uploader.bundle.css']
 * }}
 * ```
 */
class UploadModule {
    constructor() {
        closestPolifill();
    }
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: UploadModule,
            providers: [...LoadingModule.forRoot({}).providers]
        };
    }
}
UploadModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    GlobalModule,
                    LoadingModule
                ],
                declarations: [
                    UploadComponent,
                    ImgUploadComponent,
                    DescriptionComponent,
                ],
                exports: [
                    UploadComponent,
                    ImgUploadComponent,
                    DescriptionComponent,
                ]
            },] }
];
/** @nocollapse */
UploadModule.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/upload-file.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UploadFile {
}
if (false) {
    /** @type {?} */
    UploadFile.prototype.name;
    /** @type {?} */
    UploadFile.prototype.fileid;
    /** @type {?} */
    UploadFile.prototype.thumbnailUrl;
    /** @type {?} */
    UploadFile.prototype.transform;
    /** @type {?} */
    UploadFile.prototype.description;
    /** @type {?} */
    UploadFile.prototype.represent;
    /** @type {?} */
    UploadFile.prototype.progress;
    /** @type {?} */
    UploadFile.prototype.site;
    /** @type {?} */
    UploadFile.prototype.path;
    /** @type {?} */
    UploadFile.prototype.filePath;
    /** @type {?} */
    UploadFile.prototype.size;
}
class UploadTransformFile {
}
if (false) {
    /** @type {?} */
    UploadTransformFile.prototype.name;
    /** @type {?} */
    UploadTransformFile.prototype.type;
    /** @type {?} */
    UploadTransformFile.prototype.thumbnailUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-upload.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ClippedInfo, DescriptionComponent, ImgUploadComponent, UPLOAD_ASSETS, UploadComponent, UploadFile, UploadModule, UploadSetting, uploadAssetsDefaultConfig };
//# sourceMappingURL=techmore-upload.js.map
